"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPriceLowest = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const andes_react_1 = require("@yonderland/andes-react");
const ProductPriceLowest = () => (0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { color: "subtle", children: "WIP: Lowest price, coming soon" });
exports.ProductPriceLowest = ProductPriceLowest;
